import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let ownerFilter = localStorage.getItem("fh_owner_filter") || "";
export const getOwnerFilter = () => ownerFilter;
export const setOwnerFilter = (id) => {
  ownerFilter = id || "";
  if (ownerFilter) localStorage.setItem("fh_owner_filter", ownerFilter); else localStorage.removeItem("fh_owner_filter");
};
api.interceptors.request.use((config) => {
  if (ownerFilter) config.headers["X-Owner-Filter"] = ownerFilter;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const { config, response } = error;
    const url = config?.url || "";
    if (response?.status !== 401 || config.__retried || url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/logout")) {
      return Promise.reject(error);
    }
    config.__retried = true;
    try {
      refreshing = refreshing || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
      await refreshing;
      return api(config);
    } catch (e) {
      return Promise.reject(error);
    }
  },
);

export const formatTRY = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(Number(n) || 0);

export const formatNum = (n, d = 1) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: d }).format(Number(n) || 0);

export async function downloadExport(path, params, filename) {
  const res = await api.get(path, { params: { ...(params || {}), _t: Date.now() }, responseType: "blob", headers: { "Cache-Control": "no-cache" } });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export const todayISO = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const toNum = (v) => {
  if (typeof v === "number") return v;
  const n = parseFloat(String(v ?? "").replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
